import { List } from 'immutable'
import React from 'react'
import { InView } from 'react-intersection-observer'
import { any, fromJSX, nothing, Updater, Widget } from 'widgets-for-react'
import { toggleInViewClass } from '../../../../Shared/Frontend/utils/inview'
import { slugify } from '../../../../Shared/Frontend/utils/slugify'
import { pushDatalayer } from '../../seo/datalayer'
import { State } from '../cmsPage.widget'
import { ModernBlock, ModernBlockProps, SeoEvent } from './modernBlocks.state'
import { importModernBlocks } from './modernBlocksImport'

importModernBlocks()

export const modernBlocksWidget = (
  modernBlocks: List<ModernBlockProps>,
  setRootState: (_: Updater<State>) => void,
  currentRootState: State
): Widget<Updater<List<ModernBlockProps>>> => {
  return any([
    ...modernBlocks.toArray().map((_b, blockIndex: number) => {
      return fromJSX<Updater<List<ModernBlockProps>>>((setState) => {
        let blockAdapters = window['modernBlocks' as any] as any
        let maybeAdapter: ModernBlock<any, any, any> = blockAdapters[_b.kind]
        let widget = nothing<Updater<any>>()

        if (maybeAdapter != undefined) {
          widget = maybeAdapter.render(setRootState, currentRootState, blockIndex, _b.props, 0).wrapHTML((jsx) => {
            let onClick = undefined
            let onMouseOver = undefined
            let onKeyPress = undefined

            if (maybeAdapter.seoEvents && maybeAdapter.seoEvents.length > 0) {
              const pushSeoEventToDatalayer = (element: SeoEvent) => {
                pushDatalayer({
                  category: element.category,
                  action: element.action,
                  label: element.label,
                  event: 'event.gtm'
                })
              }
              onClick = (e: any) => {
                const elements =
                  maybeAdapter.seoEvents &&
                  maybeAdapter.seoEvents(_b.props, blockIndex).filter((e) => e.event == 'onClick')
                const element = elements?.find((element) => element.id == (e.target as any).id)
                if (element) {
                  pushSeoEventToDatalayer(element!)
                }
              }
              onMouseOver = (e: any) => {
                const elements =
                  maybeAdapter.seoEvents &&
                  maybeAdapter.seoEvents(_b.props, blockIndex).filter((e) => e.event == 'onMouseOver')
                const element = elements?.find((element) => element.id == (e.target as any).id)
                if (element) {
                  pushSeoEventToDatalayer(element!)
                }
              }
              onKeyPress = (e: any) => {
                const elements =
                  maybeAdapter.seoEvents &&
                  maybeAdapter.seoEvents(_b.props, blockIndex).filter((e) => e.event == 'onKeyPress')
                const element = elements?.find((element) => element.id == (e.target as any).id)
                if (element) {
                  pushSeoEventToDatalayer(element!)
                }
              }
            }

            const sharedProps = {
              id: `${slugify(`block-${blockIndex}`)}`, // ${slugify(htmlDecode(_b.props.anchorTitle))}
              onClick: onClick,
              onMouseOver: onMouseOver,
              onKeyPress: onKeyPress,
              className:
                maybeAdapter.blockClassName == undefined
                  ? ''
                  : typeof maybeAdapter.blockClassName == 'string'
                  ? maybeAdapter.blockClassName
                  : maybeAdapter.blockClassName(_b.props)
            }

            if (maybeAdapter.inView) {
              jsx = (
                <InView
                  key={slugify(`block-${blockIndex}`)}
                  as={(maybeAdapter.inView.showAs as any) || 'section'}
                  threshold={maybeAdapter.inView.threshold || 0.1}
                  triggerOnce={maybeAdapter.inView.triggerOnce}
                  onChange={(isInView, entry) => {
                    toggleInViewClass(
                      isInView,
                      entry.target,
                      maybeAdapter.inView?.inViewClassName || '',
                      maybeAdapter.inView?.triggerOnce
                    )
                    setState((s) => {
                      let b = s.get(blockIndex)!
                      let b1 = { ...b, props: maybeAdapter.inView?.updateState(isInView, b.props) }
                      return s.set(blockIndex, b1)
                    })
                    if (isInView) {
                      pushDatalayer({
                        event: 'event.gtm',
                        category: 'show_content',
                        action: _b.kind + (_b.props['title'] ? '_' : '') + (_b.props['title'] || ''),
                        label: window.location.href
                      })
                    }
                  }}
                  {...sharedProps}
                >
                  {jsx}
                </InView>
              )
            } else {
              jsx = <section {...sharedProps}>{jsx}</section>
            }

            return jsx
          })
        }

        return widget.run((newBlockProps) =>
          setState((s) => {
            // debugger
            let b = s.get(blockIndex) as ModernBlockProps
            let b1 = { ...b, props: newBlockProps(b?.props) }
            return s.set(blockIndex, b1)
          })
        )
      })
    })
  ])
}
